import { getData, postData } from '../../../utils/fetch-api-util';

export interface GetVisibleTypeParams {
  country?: string;
}

export interface SetVisibleTypeParams {
  feature: string;
  description?: string;
  enabled: boolean;
  countryCode?: string;
  isCountry?: boolean;
}

interface SuccessResponse {
  success: boolean;
}

export const getLaunchFeaturesListRepository = async (url: string, params: GetVisibleTypeParams): Promise<any> => {
  const response = await getData<{}, {}>(url, params);
  return response.data;
};

export const postUpdateShowHideRepository = async (url: string, payload: SetVisibleTypeParams): Promise<void> => {
  await postData<SetVisibleTypeParams, SuccessResponse>(url, payload);
};
